import React from 'react';
import { Box, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { openNewTab } from 'src/common/config/FunctionHelper';
import { TrackYourAIVisibilityCSS as css } from '../style';

/**
 * Right-side promotional panel shown next to the OrbitAI feature card.
 */
export const OrbitAiSidebar: React.FC = () => {
  const sideDescription = `Orbit is five AI agents working your website and local SEO profile, scanning for issues and fixing them before they cost you visibility.`;

  return (
    <Box sx={css.sideBox}>
      <Typography sx={css.sideTitle}>
        Your Site's AI Care Team
      </Typography>
      <Typography sx={css.sideDescription}>{sideDescription}</Typography>
      <Box sx={css.sideLinkWrapper}>
        <Typography
          sx={css.sideLink}
          onClick={() => openNewTab('https://www.youtube.com/watch?v=NV_1DmzA0yk')}
        >
          Watch Our Video Guide
        </Typography>
        <ArrowForwardIcon sx={css.sideLinkIcon} />
      </Box>
    </Box>
  );
};
